import React, { Fragment } from 'react'

const HealthPage = ({ t }) => {
  return <Fragment>Healthy</Fragment>
}

export default HealthPage
